module.exports = __webpack_public_path__ + "static/media/portfolio.0a02aafc.png";